import { Suspense } from 'react';

import Button from 'core/generic/elements/button';
import Divider from 'core/generic/elements/divider';

import styles from './show-more-section.module.scss';

const DEFAULT_LABEL = 'More';

type ShowMoreSectionProps = {
	link: string;
	label?: string;
};

export const ShowMoreSection = ({ link, label }: ShowMoreSectionProps) => {
	return (
		<footer className={styles['show-more-section']}>
			<Suspense fallback={<hr />}>
				<Divider className={styles['show-more-section_divider']} />
			</Suspense>

			<Suspense fallback={<a href={link}>{label || DEFAULT_LABEL}</a>}>
				<Button
					href={link}
					label={label || DEFAULT_LABEL}
					variant="secondary"
					icon="ChevronRight"
					iconPosition="right"
					fullWidth
					className={styles['show-more-section_button']}
				/>
			</Suspense>
		</footer>
	);
};
